(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Container = include('createjs.Container'),
        Shape = include('createjs.Shape'),
        Bitmap = include('createjs.Bitmap'),
        SoundButton = include('springroll.easeljs.SoundButton'),
        Text = include('createjs.Text');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class WGBH.GamePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var GamePanel = function()
	{
		BasePanel.call(this);

	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(GamePanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		/**
		 * The constructed game stage
		 * @property {createjs.Container} skin
		 */

        // ----------------------------
		// Background Shapes / Colors 
		// ----------------------------

        this.bg = new Shape();
		this.bedBG = new Shape();
		this.scoreBG = new Shape();
		this.gridBG = new Shape();        

		this.bg.graphics.beginFill("#333333").drawRect( 0, 0, 595, 325 );
        this.bedBG.graphics.beginFill("#666").drawRect( 10, 67, 150, 250 );
        this.scoreBG.graphics.beginFill("#666").drawRect( 435, 67, 150, 250 );
        this.gridBG.graphics.beginFill("#ccc").drawRect( 173.5, 67, 248, 250 );        

        this.addChild(this.bg);
        this.addChild(this.bedBG);
        this.addChild(this.scoreBG);
        this.addChild(this.gridBG);

        // --------------------------------------------------
        // Bed
        // --------------------------------------------------

        this.bedOut = new lib.bedunmade();
        this.bedOut.x = 40;
        this.bedOut.y = 75;
        this.bedOut.regX = -50;
        this.bedOut.regY = -94;
        this.bedOut.visible = false;
        this.addChild(this.bedOut);

        this.bedsad = new lib.bedmadesad();
        this.bedsad.x = 40;
        this.bedsad.y = 75;
        this.bedsad.regX = -50;
        this.bedsad.regY = -94;
        this.bedsad.visible = false;
        this.addChild(this.bedsad);

        this.bedhappy = new lib.bedmadehappy();
        this.bedhappy.x = 40;
        this.bedhappy.y = 75;
        this.bedhappy.regX = -50;
        this.bedhappy.regY = -94;
        this.bedhappy.visible = true;
        this.addChild(this.bedhappy);

        this.helpButton = new SoundButton(images.HelpBtn);
        this.helpButton.x = 57;
        this.helpButton.y = 275;
        this.helpButton.scaleX = 0.24;
        this.helpButton.scaleY = 0.24;
        this.helpButton.visible = true;
        this.addChild(this.helpButton);

        this.audioButton = new Bitmap(images.ADBtn);
        this.audioButton.x = 17;
        this.audioButton.y = 275;
        this.audioButton.scaleX = 0.24;
        this.audioButton.scaleY = 0.24;
        this.audioButton.alpha = 1;
        this.audioButton.visible = true;
        this.audioButton.cursor = "pointer";
        this.addChild(this.audioButton);

        this.audioButton_active = new Bitmap(images.ADBtn_active);
        this.audioButton_active.x = 17;
        this.audioButton_active.y = 275;
        this.audioButton_active.scaleX = 0.24;
        this.audioButton_active.scaleY = 0.24;
        this.audioButton_active.alpha = 1;
        this.audioButton_active.visible = false;
        this.audioButton_active.cursor = "pointer";
        this.addChild(this.audioButton_active);

        if (version == 'touch') {
            this.audioButton.visible = false;
            this.audioButton_active.visible = false;

            this.helpButton.x = 17;
            this.helpButton.y = 275;
        }

        // --------------------------------------------------
        // Grid / Obstacles  i.e. this.panel.grid[1][1]; Row 1, Column 1 
        // --------------------------------------------------

        this.grid = [];
        this.obstacles = [];
    
        for( i = 0; i <= 4; i++){
            
            this.grid[ i + 1 ] = [];
            this.obstacles[ i + 1 ] = [];

        	for( n = 0; n <= 4; n++){

        		if (n === 0){
        			x = 173.5;
        		} else{
        			x = 173.5 + (50 * n);
        		}

        		if (i === 0){
        			y = 67;
        		} else {
        			y = 67 + (50 * i);
        		}

                this.obstacles[i + 1][n + 1] = {hasObstacle: false, obstacle: ''};
                this.grid[i + 1][n + 1] = new Shape();
        		this.grid[i + 1][n + 1].name = "grid_" + (i + 1) + "x" + (n + 1);
                this.grid[i + 1][n + 1].x_pos = i + 1;
                this.grid[i + 1][n + 1].y_pos = n + 1;
        		this.grid[i + 1][n + 1].graphics.beginStroke("000000").beginFill('#ccc').drawRect(0, 0, 50, 50);
                this.grid[i + 1][n + 1].x = x;
                this.grid[i + 1][n + 1].y = y;
    			this.addChild(this.grid[i +1][n + 1]);
                // console.log(this.obstacles[i + 1][n + 1]);
                // console.log(this.grid[i+1][n+1].name, "x: " + this.grid[i+1][n+1].x, "y: " + this.grid[i+1][n+1].y);
        	}
        }

        // --------------------------
        // DW
        // --------------------------
        this.dw = new Container();
        this.dwBG = new Shape();
        this.dwHead = new lib.dwhead1();
        this.dwHead.regX = -25;
        this.dwHead.regY = -25;
        this.dwHead.scaleX = 0.9;
        this.dwHead.scaleY = 0.9;
        this.dwBG.graphics.setStrokeStyle(2, "square").beginStroke("000000").beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.dw.x = 175;        
        this.dw.y = 68.5; 

        // Arrows for Hover
        //Up
        this.arrowUpBG = new Shape();
        this.arrowUpBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowUpBG.hitArea = new Shape();
        this.arrowUpBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowUp = new lib.arrow();
        this.arrowUp.x = 22;
        this.arrowUp.y = -7;
        this.arrowUp.rotation = -90;
        this.arrowUpBG.x = 0;
        this.arrowUpBG.y = -51;
        this.arrowUpBG.alpha = 0;
        this.arrowUp.alpha = 0;
        this.dw.addChild(this.arrowUpBG);
        this.dw.addChild(this.arrowUp);

        //Down
        this.arrowDownBG = new Shape();
        this.arrowDownBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowDownBG.hitArea = new Shape();
        this.arrowDownBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowDown = new lib.arrow();
        this.arrowDown.x = 22;
        this.arrowDown.y = 54;
        this.arrowDown.rotation = 90;
        this.arrowDownBG.x = 0;
        this.arrowDownBG.y = 50;

        if (version != 'touch'){
            this.arrowDownBG.alpha = 0;
            this.arrowDown.alpha = 0;
        } else {
            this.arrowDownBG.alpha = 1;
            this.arrowDown.alpha = 1;
        }
        
        this.dw.addChild(this.arrowDownBG);
        this.dw.addChild(this.arrowDown);

        //Left
        this.arrowLeftBG = new Shape();
        this.arrowLeftBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowLeftBG.hitArea = new Shape();
        this.arrowLeftBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowLeft = new lib.arrow();
        this.arrowLeft.x = -8;
        this.arrowLeft.y = 24;
        this.arrowLeft.rotation = -180;
        this.arrowLeftBG.x = -50;
        this.arrowLeftBG.y = 0;
        this.arrowLeftBG.alpha = 0;
        this.arrowLeft.alpha = 0;
        this.dw.addChild(this.arrowLeftBG);
        this.dw.addChild(this.arrowLeft);

        //Right
        this.arrowRightBG = new Shape();
        this.arrowRightBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowRightBG.hitArea = new Shape();
        this.arrowRightBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.arrowRight = new lib.arrow();
        this.arrowRight.x = 54;
        this.arrowRight.y = 22;
        this.arrowRight.rotation = 0;
        this.arrowRightBG.x = 50;
        this.arrowRightBG.y = 0;

        if (version != 'touch'){
            this.arrowRightBG.alpha = 0;
            this.arrowRight.alpha = 0;
        } else {
            this.arrowRightBG.alpha = 1;
            this.arrowRight.alpha = 1;
        }
        
        this.dw.addChild(this.arrowRightBG);
        this.dw.addChild(this.arrowRight);
        
        this.dw.addChild(this.dwBG);
        this.dw.addChild(this.dwHead);
        this.dw.visible = false;
        this.addChild(this.dw); 

        // --------------------------
        // Sink
        // --------------------------      

        this.sink = new lib.sink_graphic();
        this.sink.x = 373;
        this.sink.y = 266;
        this.sink.regX = -25;
        this.sink.regY = -25;
        this.sink.scaleY = 0.97;
        this.sink.scaleX = 0.97;
        this.sink.visible = false;
        this.addChild(this.sink);


        // -------------------------
        // Home Button
        // -------------------------

        // Home
        this.homeBtn = new SoundButton(images.HomeBtn);
        this.homeBtn.x = 10;
        this.homeBtn.y = 10;
        this.homeBtn.scaleX = 0.2;
        this.homeBtn.scaleY = 0.2;
        this.homeBtn.visible = true;
        this.homeBtn.cursor = "pointer";
        this.addChild(this.homeBtn);

        // --------------------------
        // Lives Section
        // --------------------------

        this.lives = 9;
        this.life = [];

        for (a = 0; a <= this.lives; a++) {
            if (a === 0){
                x = 90;
            } else {
                x = 90 + (50.5 * a);
            }

            this.life[a] = new Container();
            this.lifeBG = new Shape();
            this.kateSleep = new lib.bkheadsleep();

            this.lifeBG.graphics.beginFill("#ccff99").drawCircle( x, 35, 20.5 );
            this.life[a].addChild(this.lifeBG);

            this.kateSleep.regX = 32;
            this.kateSleep.regY = 5;
            this.kateSleep.scaleY = 0.8;
            this.kateSleep.scaleX = 0.8;
            this.kateSleep.x = x;
            this.kateSleep.y = 35 ;
           
            this.life[a].scaleX = 1;
            this.life[a].scaleY = 1;
            this.life[a].addChild(this.kateSleep);          
            this.addChild(this.life[a]);
        }

        // --------------------------
        // Score Section
        // --------------------------

        this.score = new Text('SCORE:', "18px Nunito", "#ffffff");
        this.score.x = 470;
        this.score.y = 80;
        this.addChild(this.score);

        this.score_num = 0;
        this.score_tally = new Text(this.score_num, "18px Nunito", "#ccff99");
        this.score_tally.x = 545;
        this.score_tally.y = 80;
        this.addChild(this.score_tally);

        var n = 0;
        this.glasses = [];
        
        for( i = 0; i < 9; i++){
            
            if (i === 0 || i == 3 || i == 6){
                x = 470;
                n++;
            } else if (i === 1 || i == 4 || i == 7){
                x = 470 + (40);
            } else if (i === 2 || i == 5 || i == 8){
                x = 470 + (80);
            }

            y = 90 + (55 * n);
            

            this.glasses[i] = new lib.waterglass();
            this.glasses[i].x = x;
            this.glasses[i].y = y;
            this.glasses[i].visible = false;
            this.addChild(this.glasses[i]);
        }

        // ----------------------------------------
        // UI Container
        // ----------------------------------------

        this.UIContainer = new Container();
        this.UIContainer.x = 173.5;
        this.UIContainer.y = 67;
        this.UIContainer.scaleX = 5;
        this.UIContainer.scaleY = 5;
        this.UIContainer.width = 250;
        this.UIContainer.height = 250;
        this.UIContainer.visible = false;
        this.addChild(this.UIContainer);

        // BG
        this.overlayBG = new Shape();
        this.overlayBG.graphics.beginFill("#fff").drawRect( 0, 0, 50, 50 );
        this.overlayBG.x = 0;
        this.overlayBG.y = 0;
        this.overlayBG.alpha = 0.8;
        this.overlayBG.visible = true;
        this.UIContainer.addChild(this.overlayBG);
       

        // Win Dialog
        this.winText = new Container();
        this.winText1 = new Text('Congratulations! You helped D.W. get 9 glasses of water without waking up Kate! That\'s enough', "15px Nunito", "#000");
        this.winText1.x = 2;
        this.winText1.y = 2;
        this.winText1lineHeight = 18;
        this.winText1.scaleX = 0.2;
        this.winText1.scaleY = 0.2;
        this.winText1.lineHeight = 19;
        this.winText1.lineWidth = 230;
        this.winText.addChild(this.winText1);

        this.winText2 = new Text('for anyone don\'t you think?', "15px Nunito", "#000");
        this.winText2.x = 16;
        this.winText2.y = 13.3;
        this.winText2.lineWidth = 140;
        this.winText2.scaleX = 0.2;
        this.winText2.scaleY = 0.2;
        this.winText2.lineHeight = 19;
        this.winText.addChild(this.winText2);

        this.winText.visible = false;
        this.UIContainer.addChild(this.winText);

        // Win DW - Water
        this.dwWater = new lib.dwwwater();
        this.dwWater.x = 9;
        this.dwWater.y = 32;
        this.dwWater.scaleX = 0.22;
        this.dwWater.scaleY = 0.22;
        this.dwWater.visible = false;
        this.UIContainer.addChild(this.dwWater);

        // Play Again - PH
        this.playAgain = new SoundButton(images.PlayAgain);
        this.playAgain.x = 38.5;
        this.playAgain.y = 38.5;
        this.playAgain.scaleX = 0.07;
        this.playAgain.scaleY = 0.07;
        this.playAgain.visible = false;
        this.playAgain.cursor = "pointer";
        this.UIContainer.addChild(this.playAgain);

        // ---------------------------------
        // Add Obstacles to Stage
        // ---------------------------------

        // Burst
        this.burst = new lib.burst();
        this.burst.x = 27;
        this.burst.y = 28;
        this.burst.scaleX = 1;
        this.burst.scaleY = 1;
        this.burst.visible = false;
        this.UIContainer.addChild(this.burst);

        // Obstacle Dialog
        this.obstacleText = new Text('Whoops! D.W. has stepped on a toy. Careful not to wake up Kate.', "15px Nunito", "#000");
        this.obstacleText.x = 2;
        this.obstacleText.y = 2;
        this.obstacleText.lineHeight = 18;
        this.obstacleText.lineWidth = 230;
        this.obstacleText.scaleX = 0.2;
        this.obstacleText.scaleY = 0.2;
        this.obstacleText.visible = false;
        this.UIContainer.addChild(this.obstacleText);

        //1
        this.obstacle1 = new lib.ball();
        this.obstacle1.x = 27;
        this.obstacle1.y = 28;
        this.obstacle1.scaleX = 0.2;
        this.obstacle1.scaleY = 0.2;
        this.obstacle1.visible = false;
        this.UIContainer.addChild(this.obstacle1); 

        //2
        this.obstacle2 = new lib.crazybus();
        this.obstacle2.x = 27;
        this.obstacle2.y = 28;
        this.obstacle2.scaleX = 0.2;
        this.obstacle2.scaleY = 0.2;
        this.obstacle2.visible = false;
        this.UIContainer.addChild(this.obstacle2);  

        //3
        this.obstacle3 = new lib.dolly();
        this.obstacle3.x = 27;
        this.obstacle3.y = 28;
        this.obstacle3.scaleX = 0.2;
        this.obstacle3.scaleY = 0.2;
        this.obstacle3.visible = false;
        this.UIContainer.addChild(this.obstacle3);  

        //4
        this.obstacle4 = new lib.ducky();
        this.obstacle4.x = 27;
        this.obstacle4.y = 28;
        this.obstacle4.scaleX = 0.2;
        this.obstacle4.scaleY = 0.2;
        this.obstacle4.visible = false;
        this.UIContainer.addChild(this.obstacle4);  

        //5
        this.obstacle5 = new lib.jackinthebox();
        this.obstacle5.x = 27;
        this.obstacle5.y = 28;
        this.obstacle5.scaleX = 0.15;
        this.obstacle5.scaleY = 0.15;
        this.obstacle5.visible = false;
        this.UIContainer.addChild(this.obstacle5);  

        //6
        this.obstacle6 = new lib.mmcow();
        this.obstacle6.x = 27;
        this.obstacle6.y = 28;
        this.obstacle6.scaleX = 0.18;
        this.obstacle6.scaleY = 0.18;
        this.obstacle6.visible = false;
        this.UIContainer.addChild(this.obstacle6); 

        //7
        this.obstacle7 = new lib.radio();
        this.obstacle7.x = 27;
        this.obstacle7.y = 28;
        this.obstacle7.scaleX = 0.2;
        this.obstacle7.scaleY = 0.2;
        this.obstacle7.visible = false;
        this.UIContainer.addChild(this.obstacle7); 

        //8
        this.obstacle8 = new lib.rattle();
        this.obstacle8.x = 27;
        this.obstacle8.y = 28;
        this.obstacle8.scaleX = 0.18;
        this.obstacle8.scaleY = 0.18;
        this.obstacle8.visible = false;
        this.UIContainer.addChild(this.obstacle8);  

        //9
        this.obstacle9 = new lib.robot();
        this.obstacle9.x = 27;
        this.obstacle9.y = 28;
        this.obstacle9.scaleX = 0.2;
        this.obstacle9.scaleY = 0.2;
        this.obstacle9.visible = false;
        this.UIContainer.addChild(this.obstacle9);

        //A
        this.obstacleA = new lib.toyphone();
        this.obstacleA.x = 27;
        this.obstacleA.y = 25;
        this.obstacleA.scaleX = 0.2;
        this.obstacleA.scaleY = 0.2;
        this.obstacleA.visible = false;
        this.UIContainer.addChild(this.obstacleA);  

        //B
        this.obstacleB = new lib.train();
        this.obstacleB.x = 27;
        this.obstacleB.y = 28;
        this.obstacleB.scaleX = 0.2;
        this.obstacleB.scaleY = 0.2;
        this.obstacleB.visible = false;
        this.UIContainer.addChild(this.obstacleB);  

        //C
        this.obstacleC = new lib.xylophone();
        this.obstacleC.x = 27;
        this.obstacleC.y = 28;
        this.obstacleC.scaleX = 0.2;
        this.obstacleC.scaleY = 0.2;
        this.obstacleC.visible = false;
        this.UIContainer.addChild(this.obstacleC);    

        // Try Again 
        this.tryAgain = new SoundButton(images.TryAgain);
        this.tryAgain.x = 38.5;
        this.tryAgain.y = 38.5;
        this.tryAgain.scaleX = 0.07;
        this.tryAgain.scaleY = 0.07;
        this.tryAgain.visible = false;
        this.tryAgain.cursor = "pointer";
        this.UIContainer.addChild(this.tryAgain);

        // Game Over Text
        this.gameOverText = new Text("Oh no! D.W. has woken up Kate!", "15px Nunito", "#000");
        this.gameOverText.x = 3;
        this.gameOverText.y = 4;
        this.gameOverText.lineHeight = 18;
        this.gameOverText.lineWidth = 230;
        this.gameOverText.scaleX = 0.2;
        this.gameOverText.scaleY = 0.2;
        this.gameOverText.visible = false;
        this.UIContainer.addChild(this.gameOverText);

        // Game Over Text
        this.gameOverText2 = new Text("GAME           OVER", "bold 25px Nunito", "#669900");
        this.gameOverText2.x = 3;
        this.gameOverText2.y = 10;
        this.gameOverText2.lineHeight = 18;
        this.gameOverText2.lineWidth = 240;
        this.gameOverText2.scaleX = 0.2;
        this.gameOverText2.scaleY = 0.2;
        this.gameOverText2.visible = false;
        this.UIContainer.addChild(this.gameOverText2);

        // Game Over Kate
        this.bkCry = new lib.bkcry();
        this.bkCry.framerate = 15;
        this.bkCry.x = 27;
        this.bkCry.y = 22;
        this.bkCry.alpha = 1;
        this.bkCry.scaleX = 0.2;
        this.bkCry.scaleY = 0.2;
        this.bkCry.visible = false;
        this.UIContainer.addChild(this.bkCry);

        // ----------------------------------------
        // Help Container
        // ----------------------------------------

        this.HelpContainer = new Container();
        this.HelpContainer.x = 0;
        this.HelpContainer.y = 0;
        this.HelpContainer.scaleX = 1;
        this.HelpContainer.scaleY = 1;
        this.HelpContainer.width = 595;
        this.HelpContainer.height = 325;
        this.HelpContainer.visible = true;
        this.addChild(this.HelpContainer);

        // ----------------------------
        // Background Shapes / Colors 
        // ----------------------------

        this.help_bg = new Shape();
        this.help_bedBG = new Shape();
        this.help_scoreBG = new Shape();
        this.help_gridBG = new Shape();        

        this.help_bg.graphics.beginFill("#333333").drawRect( 0, 0, 595, 325 );
        this.help_bedBG.graphics.beginFill("#666").drawRect( 10, 67, 150, 250 );
        this.help_scoreBG.graphics.beginFill("#666").drawRect( 435, 67, 150, 250 );
        this.help_gridBG.graphics.beginFill("#ccc").drawRect( 173.5, 67, 248, 250 );        

        this.HelpContainer.addChild(this.help_bg);
        this.HelpContainer.addChild(this.help_bedBG);
        this.HelpContainer.addChild(this.help_scoreBG);
        this.HelpContainer.addChild(this.help_gridBG);

        // --------------------------------------------------
        // Bed
        // --------------------------------------------------

        this.help_bedOut = new lib.bedunmade();
        this.help_bedOut.x = 40;
        this.help_bedOut.y = 75;
        this.help_bedOut.regX = -50;
        this.help_bedOut.regY = -94;
        this.help_bedOut.visible = false;
        this.HelpContainer.addChild(this.help_bedOut);

        this.help_bedsad = new lib.bedmadesad();
        this.help_bedsad.x = 40;
        this.help_bedsad.y = 75;
        this.help_bedsad.regX = -50;
        this.help_bedsad.regY = -94;
        this.help_bedsad.visible = false;
        this.HelpContainer.addChild(this.help_bedsad);

        this.help_bedhappy = new lib.bedmadehappy();
        this.help_bedhappy.x = 40;
        this.help_bedhappy.y = 75;
        this.help_bedhappy.regX = -50;
        this.help_bedhappy.regY = -94;
        this.help_bedhappy.visible = true;
        this.HelpContainer.addChild(this.help_bedhappy);

        this.help_helpHighlight = new Shape();
        this.help_helpHighlight.graphics.beginFill('#fff');
        if (version == 'touch'){
            this.help_helpHighlight.graphics.moveTo(25, 290).lineTo(180, 270).lineTo(180, 250).lineTo(25, 290).lineTo(25, 290);
        } else{
            this.help_helpHighlight.graphics.moveTo(70, 290).lineTo(180, 270).lineTo(180, 250).lineTo(70, 290).lineTo(70, 290);
        }
        
        this.help_helpHighlight.alpha = 0.8;
        this.HelpContainer.addChild(this.help_helpHighlight);

        this.help_helpButton = new SoundButton(images.HelpBtnAlt);
        this.help_helpButton.x = 57;
        this.help_helpButton.y = 275;
        this.help_helpButton.scaleX = 0.24;
        this.help_helpButton.scaleY = 0.24;
        this.help_helpButton.visible = true;
        this.HelpContainer.addChild(this.help_helpButton);

        this.help_audioButton = new Bitmap(images.ADBtn);
        this.help_audioButton.x = 17;
        this.help_audioButton.y = 275;
        this.help_audioButton.scaleX = 0.24;
        this.help_audioButton.scaleY = 0.24;
        this.help_audioButton.alpha = 1;
        this.help_audioButton.cursor = "pointer";
        this.help_audioButton.visible = true;
        this.HelpContainer.addChild(this.help_audioButton);

        this.help_audioButton_active = new Bitmap(images.ADBtn_active);
        this.help_audioButton_active.x = 17;
        this.help_audioButton_active.y = 275;
        this.help_audioButton_active.scaleX = 0.24;
        this.help_audioButton_active.scaleY = 0.24;
        this.help_audioButton_active.alpha = 1;
        this.help_audioButton_active.cursor = "pointer";
        this.help_audioButton_active.visible = false;
        this.HelpContainer.addChild(this.help_audioButton_active);

        if (version == 'touch') {
            this.help_audioButton.visible = false;
            this.help_audioButton_active.visible = false;

            this.help_helpButton.x = 17;
            this.help_helpButton.y = 275;
        }

        // --------------------------------------------------
        // Grid / Obstacles  i.e. this.panel.grid[1][1]; Row 1, Column 1 
        // --------------------------------------------------

        this.help_grid = [];
        this.help_obstacles = [];
    
        for( i = 0; i <= 4; i++){
            
            this.help_grid[ i + 1 ] = [];
            this.help_obstacles[ i + 1 ] = [];

            for( n = 0; n <= 4; n++){

                if (n === 0){
                    x = 173.5;
                } else{
                    x = 173.5 + (50 * n);
                }

                if (i === 0){
                    y = 67;
                } else {
                    y = 67 + (50 * i);
                }

                this.help_obstacles[i + 1][n + 1] = {hasObstacle: false, obstacle: ''};
                this.help_grid[i + 1][n + 1] = new Shape();
                this.help_grid[i + 1][n + 1].name = "grid_" + (i + 1) + "x" + (n + 1);
                this.help_grid[i + 1][n + 1].graphics.beginStroke("000000").beginFill('#ccc').drawRect(0, 0, 50, 50);
                this.help_grid[i + 1][n + 1].x = x;
                this.help_grid[i + 1][n + 1].y = y;
                this.HelpContainer.addChild(this.help_grid[i +1][n + 1]);
            }
        }

        // ----------------------------
        // Obstacle
        // ----------------------------

        // Burst
        this.help_burst = new lib.burst();
        this.help_burst.x = 200;
        this.help_burst.y = 193.5;
        this.help_burst.scaleX = 1;
        this.help_burst.scaleY = 1;
        this.help_burst.visible = false;
        this.HelpContainer.addChild(this.help_burst);

        //B
        this.help_obstacleB = new lib.train();
        this.help_obstacleB.x = 200;
        this.help_obstacleB.y = 193.5;
        this.help_obstacleB.scaleX = 0.3;
        this.help_obstacleB.scaleY = 0.3;
        this.help_obstacleB.visible = false;
        this.HelpContainer.addChild(this.help_obstacleB);  


        // ----------------------------
        // Home Button
        // ----------------------------

        // Home
        this.help_homeBtn = new SoundButton(images.HomeBtn);
        this.help_homeBtn.x = 10;
        this.help_homeBtn.y = 10;
        this.help_homeBtn.scaleX = 0.2;
        this.help_homeBtn.scaleY = 0.2;
        this.help_homeBtn.visible = true;
        this.help_homeBtn.cursor = "pointer";
        this.HelpContainer.addChild(this.help_homeBtn);

        // --------------------------
        // Sink
        // --------------------------      

        this.help_sink = new lib.sink_graphic();
        this.help_sink.x = 373;
        this.help_sink.y = 266;
        this.help_sink.regX = -25;
        this.help_sink.regY = -25;
        this.help_sink.scaleY = 0.97;
        this.help_sink.scaleX = 0.97;
        this.help_sink.visible = false;
        this.HelpContainer.addChild(this.help_sink);

        // --------------------------
        // DW
        // --------------------------
        this.help_dw = new Container();
        this.help_dwBG = new Shape();
        this.help_dwHead = new lib.dwhead1();
        this.help_dwHead.regX = -25;
        this.help_dwHead.regY = -25;
        this.help_dwHead.scaleX = 0.9;
        this.help_dwHead.scaleY = 0.9;
        this.help_dwBG.graphics.setStrokeStyle(2, "square").beginStroke("000000").beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_dw.x = 175;        
        this.help_dw.y = 68.5; 

        // Arrows for Hover
        //Up
        this.help_arrowUpBG = new Shape();
        this.help_arrowUpBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowUpBG.hitArea = new Shape();
        this.help_arrowUpBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowUp = new lib.arrow();
        this.help_arrowUp.x = 22;
        this.help_arrowUp.y = -7;
        this.help_arrowUp.rotation = -90;
        this.help_arrowUpBG.x = 0;
        this.help_arrowUpBG.y = -51;
        this.help_arrowUpBG.alpha = 0;
        this.help_arrowUp.alpha = 0;
        this.help_dw.addChild(this.help_arrowUpBG);
        this.help_dw.addChild(this.help_arrowUp);

        //Down
        this.help_arrowDownBG = new Shape();
        this.help_arrowDownBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowDownBG.hitArea = new Shape();
        this.help_arrowDownBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowDown = new lib.arrow();
        this.help_arrowDown.x = 22;
        this.help_arrowDown.y = 54;
        this.help_arrowDown.rotation = 90;
        this.help_arrowDownBG.x = 0;
        this.help_arrowDownBG.y = 50;
        this.help_arrowDownBG.alpha = 0;
        this.help_arrowDown.alpha = 0;
        this.help_dw.addChild(this.help_arrowDownBG);
        this.help_dw.addChild(this.help_arrowDown);

        //Left
        this.help_arrowLeftBG = new Shape();
        this.help_arrowLeftBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowLeftBG.hitArea = new Shape();
        this.help_arrowLeftBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowLeft = new lib.arrow();
        this.help_arrowLeft.x = -8;
        this.help_arrowLeft.y = 24;
        this.help_arrowLeft.rotation = -180;
        this.help_arrowLeftBG.x = -50;
        this.help_arrowLeftBG.y = 0;
        this.help_arrowLeftBG.alpha = 0;
        this.help_arrowLeft.alpha = 0;
        this.help_dw.addChild(this.help_arrowLeftBG);
        this.help_dw.addChild(this.help_arrowLeft);

        //Right
        this.help_arrowRightBG = new Shape();
        this.help_arrowRightBG.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowRightBG.hitArea = new Shape();
        this.help_arrowRightBG.hitArea.graphics.beginFill('#ffffff').drawRect(0, 0, 48, 48);
        this.help_arrowRight = new lib.arrow();
        this.help_arrowRight.x = 54;
        this.help_arrowRight.y = 22;
        this.help_arrowRight.rotation = 0;
        this.help_arrowRightBG.x = 50;
        this.help_arrowRightBG.y = 0;
        this.help_arrowRightBG.alpha = 0;
        this.help_arrowRight.alpha = 0;
        this.help_dw.addChild(this.help_arrowRightBG);
        this.help_dw.addChild(this.help_arrowRight);
        
        this.help_dw.addChild(this.help_dwBG);
        this.help_dw.addChild(this.help_dwHead);
        this.help_dw.visible = false;
        this.HelpContainer.addChild(this.help_dw); 
        

        // --------------------------
        // Lives Section
        // --------------------------

        this.help_lives = 9;
        this.help_life = [];

        for (a = 0; a <= this.help_lives; a++) {
            if (a === 0){
                x = 90;
            } else {
                x = 90 + (50.5 * a);
            }

            this.help_life[a] = new Container();
            this.help_lifeBG = new Shape();
            this.help_kateSleep = new lib.bkheadsleep();

            this.help_lifeBG.graphics.beginFill("#ccff99").drawCircle( x, 35, 20.5 );
            this.help_life[a].addChild(this.help_lifeBG);

            this.help_kateSleep.regX = 32;
            this.help_kateSleep.regY = 5;
            this.help_kateSleep.scaleY = 0.8;
            this.help_kateSleep.scaleX = 0.8;
            this.help_kateSleep.x = x;
            this.help_kateSleep.y = 35 ;
           
            this.help_life[a].scaleX = 1;
            this.help_life[a].scaleY = 1;
            this.help_life[a].addChild(this.help_kateSleep);          
            this.HelpContainer.addChild(this.help_life[a]);
        }

        // --------------------------
        // Score Section
        // --------------------------

        this.help_score = new Text('SCORE:', "18px Nunito", "#ffffff");
        this.help_score.x = 470;
        this.help_score.y = 80;
        this.HelpContainer.addChild(this.help_score);

        this.help_score_num = 0;
        this.help_score_tally = new Text(this.help_score_num, "18px Nunito", "#ccff99");
        this.help_score_tally.x = 545;
        this.help_score_tally.y = 80;
        this.HelpContainer.addChild(this.help_score_tally);

        var s = 0;
        this.help_glasses = [];
        
        for( i = 0; i < 9; i++){
            
            if (i === 0 || i == 3 || i == 6){
                x = 470;
                s++;
            } else if (i === 1 || i == 4 || i == 7){
                x = 470 + (40);
            } else if (i === 2 || i == 5 || i == 8){
                x = 470 + (80);
            }

            y = 90 + (55 * s);
            

            this.help_glasses[i] = new lib.waterglass();
            this.help_glasses[i].x = x;
            this.help_glasses[i].y = y;
            this.help_glasses[i].visible = false;
            this.HelpContainer.addChild(this.help_glasses[i]);
            // console.log("Glass: " + this.glasses[i]);
        }

        // BG
        this.help_overlayBG = new Shape();
        this.help_overlayBG.graphics.beginFill("#fff").drawRect( 0, 0, 50, 50 );
        this.help_overlayBG.x = 173.5;
        this.help_overlayBG.y = 67;
        this.help_overlayBG.scaleX = 5;
        this.help_overlayBG.scaleY = 5;
        this.help_overlayBG.width = 250;
        this.help_overlayBG.height = 250;
        this.help_overlayBG.alpha = 0.8;
        this.help_overlayBG.visible = true;
        this.HelpContainer.addChild(this.help_overlayBG);

        // ---------------------------------------
        // Step 1
        // ---------------------------------------

        // Play - PH
        this.help_playBtn = new SoundButton(images.PlayBtn);
        this.help_playBtn.x = 275;
        this.help_playBtn.y = 260;
        this.help_playBtn.scaleX = 0.3;
        this.help_playBtn.scaleY = 0.3;
        this.help_playBtn.visible = true;
        this.help_playBtn.cursor = "pointer";
        this.HelpContainer.addChild(this.help_playBtn);

        // Next Button
        this.help_nextBtn = new SoundButton(images.NextBtn);
        this.help_nextBtn.x = 365;
        this.help_nextBtn.y = 260;
        this.help_nextBtn.scaleX = 0.3;
        this.help_nextBtn.scaleY = 0.3;
        this.help_nextBtn.visible = true;
        this.help_nextBtn.cursor = "pointer";
        this.HelpContainer.addChild(this.help_nextBtn);

        // Welcome to
        this.help_welcome = new Text('Welcome to', "bold 18px Nunito", "#000");
        this.help_welcome.x = 248;
        this.help_welcome.y = 72;
        this.help_welcome.scaleX = 1;
        this.help_welcome.scaleY = 1;
        this.help_welcome.visible = true;
        this.HelpContainer.addChild(this.help_welcome);

        // Kate Bg
        this.help_kateBG = new Shape();
        this.help_kateBG.graphics.beginFill("#ccc").drawEllipse( 0, 0, 110, 70 );
        this.help_kateBG.x = 242;
        this.help_kateBG.y = 130;
        this.help_kateBG.alpha = 1;
        this.help_kateBG.scaleX = 1;
        this.help_kateBG.scaleY = 1;
        this.help_kateBG.visible = true;
        this.HelpContainer.addChild(this.help_kateBG);

        // DWK Logo
        this.help_logo = new lib.DWKlogo();
        this.help_logo.x = 295;
        this.help_logo.y = 128;
        this.help_logo.alpha = 1;
        this.help_logo.scaleX = 1;
        this.help_logo.scaleY = 1;
        this.help_logo.visible = true;
        this.HelpContainer.addChild(this.help_logo);

        // BK Head Cry
        this.help_bkHeadCry = new lib.bkheadcry();
        this.help_bkHeadCry.framerate = 15;
        this.help_bkHeadCry.x = 308.5;
        this.help_bkHeadCry.y = 185;
        this.help_bkHeadCry.alpha = 1;
        this.help_bkHeadCry.scaleX = 1;
        this.help_bkHeadCry.scaleY = 1;
        this.help_bkHeadCry.visible = true;
        this.HelpContainer.addChild(this.help_bkHeadCry);  

        // Directions Text
        this.help_introText = new Text('For directions, click the arrow. When you are ready to play, hit PLAY', "14px Nunito", "#000");
        this.help_introText.x = 198;
        this.help_introText.y = 205;
        this.help_introText.lineWidth = 200;
        this.help_introText.lineHeight = 20;
        this.help_introText.scaleX = 1;
        this.help_introText.scaleY = 1;
        this.help_introText.visible = true;
        this.HelpContainer.addChild(this.help_introText);

        // -------------------------------
        // Step 2
        // -------------------------------

        this.help_stepText = new Text('D.W. is thirsty. Help her cross the dark room to get a glass of water', "15px Nunito", "#000");
        this.help_stepText.x = 283.5;
        this.help_stepText.y = 75;
        this.help_stepText.lineWidth = 135;
        this.help_stepText.lineHeight = 18;
        this.help_stepText.scaleX = 1;
        this.help_stepText.scaleY = 1;
        this.help_stepText.visible = false;
        this.HelpContainer.addChild(this.help_stepText);    

	};


	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		s.teardown.call(this);
		this.skin = null;
		this.shape = null;
	};

	//Assign to namespace
	namespace('WGBH').GamePanel = GamePanel;
}());